import { Divider, Flex, Icon, Text, spaces } from '@electricjs/arc';

type SearchHintOptionProps = {
  label: string;
};

export const SearchHintOption = ({ label }: SearchHintOptionProps) => (
  <Flex
    flexDirection="column"
    alignItems="center"
    width="100%"
    gap={spaces.space_xs}>
    <Divider />
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100%"
      gap={spaces.space_xs}
      py={spaces.space_3xs}>
      <Icon icon="search" size="xsmall" intent="secondary" />
      <Text variant="legal" intent="secondary">
        {label}
      </Text>
    </Flex>
  </Flex>
);
